import Link from 'next/link';

import { classNames } from '@/utils/classNames';

import Iconosquare from '@/components/icons/Iconosquare';

type SparksSourceChipProps = {
    label: string;
    href: string;
};

export function SparksSourceChip({ label, href }: SparksSourceChipProps) {
    const baseClass = classNames(
        'inline-flex max-w-full min-w-0 cursor-pointer items-center gap-1 rounded bg-icoGray-100 p-[5px]',
        'transition-opacity hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-icoBlue focus-visible:ring-offset-1 dark:bg-icoDarkMode-anthracite/80 dark:focus-visible:ring-offset-icoDarkMode-anthracite'
    );

    const content = (
        <>
            <Iconosquare size={10} className="shrink-0 text-icoBlue" aria-hidden />
            <span className="min-w-0 truncate font-GSemiBold text-xs leading-[14px] tracking-[-0.072px] text-icoBlack dark:text-white">
                {label}
            </span>
        </>
    );

    if (href.startsWith('/')) {
        return (
            <Link href={href} className={baseClass}>
                {content}
            </Link>
        );
    }

    return (
        <a href={href} target="_blank" rel="noopener noreferrer" className={baseClass}>
            {content}
        </a>
    );
}
